import React from "react";
export const InitialPaginationContext = /*#__PURE__*/ React.createContext(undefined);
export const useInitialPagination = ()=>{
    const ctx = React.useContext(InitialPaginationContext);
    if (!ctx) throw new Error("Initial pagination context is empty");
    return ctx;
};
